import { axiosInstance } from '../request';
export const downloadChat = async () => {
    const response = await axiosInstance.get(`/api/v1/users/messages/export`, {
        responseType: 'blob'
    });
    return response.data;
};
//# sourceMappingURL=users.api.js.map